<template>
	<div id :class="collectionHasValues(form) ? 'hasOptions' : ''">
		<el-button v-if="showAdd && fixedCollectionObject.options.length === 1" plain @click="addToFixedCollection"
			style="width: 100%; margin-bottom: 10px" type="primary">
			{{ fixedCollectionObject.placeholder || "Add" }}
		</el-button>
		<el-dropdown style="width: 100%; margin-bottom: 10px" plain
			v-if="showAdd && fixedCollectionObject.options.length > 1">
			<el-button plain style="width: 100%" type="primary">
				{{ fixedCollectionObject.placeholder || "Add" }}
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item :key="option.name" v-for="option in fixedCollectionObject.options"
					@click.native="addToFixedCollection(option.name)">
					{{ option.displayName }}
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-form ref="form" label-position="top" label-width="100px" :model="form">
			<span :key="option.name + index" v-for="(option, index) in fixedCollectionObject.options">
				<span v-if="Array.isArray(form[option.name])">
					<span style="position: relative" :key="i" v-for="(value, i) in form[option.name]">
						<span :key="returnPropertyDef(key, value.ref).name + i" v-for="(key, i) in Object.keys(value)">
							<el-form-item
								v-if="determineIfToShowField(returnPropertyDef(key, value.ref).displayOptions, value)"
								:label="returnPropertyDef(key, value.ref).type === 'notice'
									? ''
									: returnPropertyDef(key, value.ref).displayName
									">
								<paramsInterfaceElement :form="value" :rootForm="rootForm"
									:hideVariableToggle="hideVariableToggle"
									:property="returnPropertyDef(key, value.ref)"
									:integrationInterface="integrationInterface" />
							</el-form-item>
						</span>
						<el-button class="remove" @click="removeFromFixedCollection(option, i)" type="danger"
							icon="el-icon-delete" circle></el-button>
						<div class="customDivider"
							v-if="fixedCollectionObject.options.length === 1 && form[option.name].length - 1 !== i">
						</div>
						<div class="customDivider" v-if="fixedCollectionObject.options.length > 1"></div>
					</span>
				</span>
				<!-- Different interfaces depending on if property is array or object -->
				<span v-if="!Array.isArray(form[option.name])">
					<span style="position: relative">
						<span :key="returnPropertyDef(key).name" v-for="key in Object.keys(form[option.name])">
							<el-form-item
								v-if="determineIfToShowField(returnPropertyDef(key).displayOptions, form[option.name])"
								:label="returnPropertyDef(key).type === 'notice' ? '' : returnPropertyDef(key).displayName
									">
								<paramsInterfaceElement :form="form[option.name]" :rootForm="rootForm"
									:property="returnPropertyDef(key)" :integrationInterface="integrationInterface"
									:hideVariableToggle="hideVariableToggle" />
							</el-form-item>
							<el-button class="remove" @click="removeFromFixedCollection(option)" type="danger"
								icon="el-icon-delete" circle></el-button>
						</span>
					</span>
				</span>
			</span>
		</el-form>
	</div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
	name: "fixedCollectionInterfaceElement",
	computed: {
		...mapGetters(["returnActiveWorkflow"]),
	},
	components: {
		paramsInterfaceElement: () => import("./paramsInterfaceElement.vue"),
	},
	props: {
		form: Object,
		fixedCollectionObject: Object,
		integrationInterface: Object,
		rootForm: Object,
		hideVariableToggle: Boolean
	},
	data() {
		return {
			showAdd: true,
		};
	},
	watch: {
		form: {
			handler() {
				this.determineIfToShowAddToCollection();
			},
			deep: true,
		},
	},
	beforeMount() {
		this.populateFormData();
		this.determineIfToShowAddToCollection();
	},
	methods: {
		populateFormData() {
			this.fixedCollectionObject.options.forEach((option) => {
				const defaultProperty = this.fixedCollectionObject?.typeOptions?.multipleValues ? [] : {};
				if (!this.form[option.name]) {
					this.$set(this.form, option.name, defaultProperty);
				} else {
					//Add ref value to objects that already exist
					if (Array.isArray(this.form[option.name])) {
						this.form[option.name].forEach((object) => {
							Object.defineProperty(object, "ref", {
								enumerable: false,
								writable: true,
							});
							object.ref = option.name;
						});
					} else if (typeof this.form[option.name] === 'object') {
						Object.defineProperty(this.form[option.name], "ref", {
							enumerable: false,
							writable: true,
						});
						this.form[option.name].ref = option.name;
					}
				}
			});
		},
		addToFixedCollection(optionName) {
			let option = this.fixedCollectionObject.options[0];
			if (optionName && this.fixedCollectionObject.options.length > 1) {
				option = this.fixedCollectionObject.options.find((each) => {
					return each.name === optionName;
				});
			}
			const object = {};
			Object.defineProperty(object, "ref", {
				enumerable: false,
				writable: true,
			});
			object.ref = option.name;
			option.values.forEach((value) => {
				let propertyDefault = value.default;
				if (value.type === "fixedCollection" && Array.isArray(propertyDefault)) {
					//Fixed collections should always be objects
					propertyDefault = {};
				}
				object[value.name] = _.cloneDeep(propertyDefault);
			});
			if (Array.isArray(this.form[option.name])) {
				this.form[option.name].push(object);
			} else {
				this.form[option.name] = object;
			}
		},
		returnPropertyDef(key, refName) {
			let option;
			if (refName) {
				option = this.fixedCollectionObject.options.find((each) => {
					return each.name === refName;
				});
			} else {
				option = this.fixedCollectionObject.options[0];
			}
			const relevantValueDef = option.values.find((value) => {
				return value.name === key;
			});
			if (relevantValueDef) {
				const cloned = _.cloneDeep(relevantValueDef);
				if (cloned.specifics?.isSensitiveField) {
					cloned.typeOptions = {
						...(cloned.typeOptions || {}),
						password: true,
					};
				}
				return cloned;
			}
		},
		determineIfToShowAddToCollection() {
			if (
				!this.fixedCollectionObject.typeOptions ||
				(this.fixedCollectionObject.typeOptions && !this.fixedCollectionObject.typeOptions.multipleValues)
			) {
				for (let key in this.form) {
					if (!Array.isArray(this.form[key]) && Object.keys(this.form[key]).length) {
						this.showAdd = false;
						return;
					}
				}
			}
			this.showAdd = true;
		},
		collectionHasValues(fixedCollection) {
			for (let key in fixedCollection) {
				if (Array.isArray(fixedCollection[key]) && fixedCollection[key].length) {
					return true;
				}
				if (!Array.isArray(fixedCollection[key]) && Object.keys(fixedCollection[key]).length) {
					return true;
				}
			}
			return false;
		},
		removeFromFixedCollection(option, index) {
			if (Array.isArray(this.form[option.name])) {
				for (var i = this.form[option.name].length - 1; i >= 0; i--) {
					if (i === index) {
						this.form[option.name].splice(index, 1);
						break;
					}
				}
			} else {
				this.form[option.name] = {};
			}
		},
		determineIfToShowField(displayOptions, value) {
			if (!displayOptions) {
				return true;
			}
			if (displayOptions.show) {
				for (let key in displayOptions.show) {
					const correspondingPropertyInData = value[key];
					const listOfPermissableValues = displayOptions.show[key];
					if (!listOfPermissableValues.includes(correspondingPropertyInData)) {
						return false;
					}
				}
			}
			if (displayOptions.hide) {
				for (let [index, [key]] of Object.entries(Object.entries(displayOptions.hide))) {
					index = parseInt(index);
					const correspondingPropertyInData = value[key];
					const listOfValuesNotAllowed = displayOptions.hide[key];
					if (correspondingPropertyInData && !listOfValuesNotAllowed.includes(correspondingPropertyInData)) {
						//Return true to display the property if any one of the hide relevant keys is not set to one of its specified properties
						//Display rule has thus failed, thus we show the field as its the inverse of 'hide'
						return true;
					}
					if (Object.entries(Object.entries(displayOptions.hide)).length - 1 === index) {
						if (listOfValuesNotAllowed.includes(correspondingPropertyInData)) {
							//On the last index if the property of the key in data is set to a specified value then all hide keys have some value that means the field should be hidden
							//Display rule has thus passed, thus we hide the field as this is what the hide rule wishes us to do
							return false;
						}
					}
				}
			}
			return true;
		},
	},
};
</script>

<style scoped>
.hasOptions {
	border: 1px dashed #210f3c;
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 10px;
	border-radius: 4px;
}

.customDivider {
	margin-bottom: 20px;
	margin-top: 20px;
	height: 0;
	width: 100%;
	border-bottom: 1px dashed #210f3c;
}

.remove {
	position: absolute;
	top: 6px;
	padding: 8px;
	right: 0px;
}
</style>
